var map = {
	"./personal-class/ideacollage.png": 79297,
	"./rent-a-bench/benches.png": 13079,
	"./rent-a-bench/sunnybenches.png": 28702,
	"./rent-a-bench/tools.png": 7370,
	"./ring-intensive/archrings.png": 64032,
	"./ring-intensive/firstrings.png": 63158,
	"./ring-intensive/funrings.png": 94980,
	"./wax-carving-week/banner.png": 81998,
	"./wax-carving-week/extra.png": 51856,
	"./wax-carving-week/poster.png": 96208,
	"./wax-carving-week/schedule.png": 7374,
	"./wax-carving-week/summerweek1.png": 85568,
	"./wax-carving-workshop/rings.png": 51867,
	"./wax-carving-workshop/waxtosilver.png": 77811,
	"./wax-carving-workshop/zilverring.png": 56601,
	"./wax-tryouts/26.png": 63292,
	"./wax-tryouts/27.png": 15990,
	"./wax-tryouts/28.png": 78830,
	"./wax-tryouts/29.png": 35989
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 271;